// --- Shipment Status ---
export enum ShipmentStatus {
  DRAFT = 0,
  IN_TRANSIT = 1,
  ARRIVED = 2,
  IN_RECEIVING = 3,
  COMPLETED = 4,
}

export const ShipmentStatusLabel: Record<number, string> = {
  [ShipmentStatus.DRAFT]: 'Draft',
  [ShipmentStatus.IN_TRANSIT]: 'In Transit',
  [ShipmentStatus.ARRIVED]: 'Arrived',
  [ShipmentStatus.IN_RECEIVING]: 'In Receiving',
  [ShipmentStatus.COMPLETED]: 'Completed',
};

export const ShipmentStatusColor: Record<number, string> = {
  [ShipmentStatus.DRAFT]: 'bg-gray-300 text-white',
  [ShipmentStatus.IN_TRANSIT]: 'bg-orange text-white',
  [ShipmentStatus.ARRIVED]: 'bg-emerald text-white',
  [ShipmentStatus.IN_RECEIVING]: 'bg-blue text-white',
  [ShipmentStatus.COMPLETED]: 'bg-green text-white',
};

// --- Package Status ---
export enum PackageStatus {
  DRAFT = 0,
  LABELED = 1,
  IN_TRANSIT = 2,
  ARRIVED = 5,
  RECEIVED = 3,
  CANCELED = 4,
}

export const PackageStatusLabel: Record<number, string> = {
  [PackageStatus.DRAFT]: 'Draft',
  [PackageStatus.LABELED]: 'Labeled',
  [PackageStatus.IN_TRANSIT]: 'In Transit',
  [PackageStatus.ARRIVED]: 'Arrived',
  [PackageStatus.RECEIVED]: 'Received',
  [PackageStatus.CANCELED]: 'Canceled',
};

// Uses class combinations that actually resolve in this project's Tailwind setup:
//   - `bg-gray-{shade}` / `text-gray-{shade}`     — project's gray palette via CSS vars
//   - `bg-amber-{shade}` / `text-amber-{shade}`   — Tailwind default amber palette (not overridden)
//   - `bg-orange` / `bg-blue` / `bg-emerald` / `bg-red` — accent single-colour vars
// Matches the visible pattern of `ShipmentStatusColor` above.
export const PackageStatusColor: Record<number, string> = {
  [PackageStatus.DRAFT]: 'bg-gray-200 text-gray-700',
  [PackageStatus.LABELED]: 'bg-amber-100 text-amber-700',
  [PackageStatus.IN_TRANSIT]: 'bg-orange text-white',
  [PackageStatus.ARRIVED]: 'bg-blue text-white',
  [PackageStatus.RECEIVED]: 'bg-emerald text-white',
  [PackageStatus.CANCELED]: 'bg-red text-white',
};

export const isPackageVerified = (pkg: { status: PackageStatus; received_qty?: number; qty?: number } | null | undefined): boolean => {
  if (!pkg) return false;
  if (pkg.status === PackageStatus.RECEIVED || pkg.status === PackageStatus.ARRIVED) return true;
  if (pkg.received_qty != null && pkg.qty != null && pkg.qty > 0 && pkg.received_qty >= pkg.qty) return true;
  return false;
};
